//
//  Default.tsx
//
//  isana.net,inc. Proprietary and Confidential
import {
  Box,
  Button,
  Container,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  AppBar,
  Toolbar,
} from "@mui/material";
import { Link } from "react-router-dom";
import IsnLogo from "../IsnLogo";
import {
  BLOOD_PRESSURE_USED,
  CSV_EXPORT_USED,
  GOOGLE_HEALTH_CSV_EXPORT_ENABLED,
  CONTACT_URL,
} from "../../utils/env";
import PropTypes from "prop-types";
import { PageTitle } from "../PageTitle";
import LogoutIcon from "@mui/icons-material/Logout";
import { useState } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MenuIcon from "@mui/icons-material/Menu";
import TitleBar from "../TitleBar";

interface AdminMainDefaultProps {
  logout: (event: any) => Promise<void>;
}

export const AdminMainDefault: React.FC<AdminMainDefaultProps> = ({
  logout,
}) => {
  return (
    <>
      <TitleBar contactUrl={CONTACT_URL} />

      <Container
        sx={{
          my: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <PageTitle title="管理者用トップページ" />
        <Stack spacing={5} alignItems="center" sx={{ mt: 5 }}>
          <Button
            variant="contained"
            component={Link}
            to="../FitbitIntegration"
            style={{ width: "250px" }}
          >
            ユーザ連携解除
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="../FitinsightUserList"
            style={{ width: "250px" }}
          >
            連携済みユーザ一覧
          </Button>
          {CSV_EXPORT_USED && (
            <Button
              variant="contained"
              component={Link}
              to="../CsvExport"
              style={{ width: "250px" }}
            >
              CSVダウンロード
            </Button>
          )}
          {GOOGLE_HEALTH_CSV_EXPORT_ENABLED && (
            <Button
              variant="contained"
              component={Link}
              to="../GhaCsvExport"
              style={{ width: "250px" }}
            >
              GHA CSVダウンロード
            </Button>
          )}
          {BLOOD_PRESSURE_USED && (
            <>
              <Button
                variant="contained"
                component={Link}
                to="../BloodPressureRegistration"
                style={{ width: "250px" }}
              >
                血圧登録
              </Button>

              <Button
                variant="contained"
                component={Link}
                to="../ImportUser"
                style={{ width: "250px" }}
              >
                ユーザ登録
              </Button>
            </>
          )}
        </Stack>
      </Container>
    </>
  );
};
AdminMainDefault.propTypes = {
  logout: PropTypes.func.isRequired,
};
